import BalanceTree from '@arcxgame/contracts/dist/src/MerkleTree/BalanceTree'
import { MerkleDistributorFactory } from '@arcxgame/contracts/dist/src/typings'
import { eqIgnoreCase } from '@arcxmoney/arcx-core'
import { useAsync } from '@arcxmoney/arcx-react'
import { useWeb3React } from '@web3-react/core'
import { BigNumber } from 'ethers'
import React, { useContext, useState } from 'react'
import Confetti from 'react-confetti'
import { ArcContext } from 'src/contexts/ArcContext'
import { useConfetti } from 'src/hooks/useConfetti'
import { cutPrecision, formatBigNumber } from 'src/utils/format/formatBigNumber'
import { ArcButton } from '../ArcButton'
import './Claim.scss'

export type Distribution = {
  account: string
  amount: BigNumber
}

interface IProps {
  distributorAddress: string
  distribution: Distribution[]
}

export function Claim({ distributorAddress, distribution }: IProps) {
  const [allocationTree] = useState(() => new BalanceTree(distribution))
  const { account } = useWeb3React()
  const { arc, isLoading, setIsLoading } = useContext(ArcContext)
  const { confetti, showConfetti } = useConfetti(false)

  const allocationEntry = distribution.find((row) => eqIgnoreCase(row.account, account))
  const index = distribution.indexOf(allocationEntry)

  const merkleDistributorContract = MerkleDistributorFactory.connect(distributorAddress, arc.signer)

  const [isClaimed] = useAsync(async () => {
    if (isLoading) {
      return
    }
    if (index < 0) {
      return false
    }
    return merkleDistributorContract.isClaimed(index)
  }, [isLoading, arc])
  const [isActive] = useAsync(async () => merkleDistributorContract.active(), [isLoading, arc])

  return (
    <>
      {confetti && <Confetti numberOfPieces={1000} recycle={false} />}
      <div className="claim">
        <div className="claim__subtitle">Claimable ARCx Tokens</div>
        <div className="claim__balance">
          {' '}
          {cutPrecision(formatBigNumber(allocationEntry?.amount), 8)}{' '}
        </div>
        <div className="claim__box">
          <p className="claim__message">
            {isActive ? 'Thank you, upwards and onwards 🚀' : 'Tokens not claimable yet'}
          </p>
          <ArcButton
            name={isClaimed ? 'Claimed' : 'Claim'}
            type="primary"
            onClick={async () => {
              setIsLoading(true)
              const proof = allocationTree.getProof(
                index,
                allocationEntry.account,
                allocationEntry.amount,
              )
              const { wait } = await merkleDistributorContract.claim(
                index,
                allocationEntry.account,
                allocationEntry.amount,
                proof,
              )
              await wait()
              setIsLoading(false)
              showConfetti()
            }}
            loading={isLoading || isClaimed === undefined}
            className="claim__button"
            disabled={!allocationEntry || isClaimed || !isActive}
          />
        </div>
      </div>
    </>
  )
}
